import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useGoBack } from '@libs/hooks/useGoBack';

import { ClockControlType } from '@features/shared/api/typings';
import { PlayerProfilePageWidget } from '@features/user/pages/PlayerProfilePage/PlayerProfilePageWidget';

export const Route = createFileRoute('/profile/stats/')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const goBack = useGoBack({
    to: '/profile',
    from: '/',
    replace: true,
  });
  const setIsClubsAndTournamentsOpen = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        navigate({
          to: '/profile/clubs-and-tournaments',
          from: '/',
        });
      }
    },
    [navigate],
  );

  const setIsEloStatsModalOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        goBack();
      }
    },
    [goBack],
  );

  const setOpenFullGamesList = useCallback(
    (clockControlType?: ClockControlType) => {
      if (clockControlType) {
        navigate({
          to: `/profile/stats/${clockControlType.toLowerCase()}`,
          from: '/',
        });
      }
    },
    [navigate],
  );

  return (
    <PlayerProfilePageWidget
      isEloStatsModalOpen
      setIsEloStatsModalOpen={setIsEloStatsModalOpen}
      isClubsAndTournamentsOpen={false}
      setIsClubsAndTournamentsOpen={setIsClubsAndTournamentsOpen}
      setOpenFullGamesList={setOpenFullGamesList}
    />
  );
}
